import { store } from "../../../redux/store"
import { setKYCReminderModalOpen } from "./redux/KYCReminderModalSlice"

const modalOpen = store.getState().kycReminderModalState.open

export const showKYCReminderModal = () => {
  // First, check if KYC process is already in progress by checking user data
  const userData = store.getState().userData.value
  const documentLabel = userData?.labels?.find(label => label.key === "document")
  const kycStatus = documentLabel?.value

  // Don't show the modal if KYC is in progress (except kyc_pending) or if we're on the KYC page or modal is already open
  if (
    ((kycStatus === 'sdk_started' || kycStatus === 'sdk_completed') &&
      kycStatus !== 'kyc_pending' &&
      kycStatus !== 'sdk_pending') ||
    window.location.pathname.includes("/kyc") ||
    modalOpen
  ) {
    return
  }

  // Show the modal if status is 'not_started', 'sdk_not_started', 'kyc_pending', 'sdk_pending', or any other status that requires KYC
  store.dispatch(setKYCReminderModalOpen(true))

  // Commented code preserved
  // if (
  //   (
  //     userData?.labels.find((el) => el.key === "document")?.value === "pending" ||
  //     userData?.labels.find((el) => el.key === "document")?.value === "in_progress"
  //   )
  // ) {
  //   store.dispatch(setKYCReminderModalOpen(true))
  //   store.dispatch(setKYCReminderModalType("pending"))
  // } else if (
  //   userData?.labels.find((el) => el.key === "document")?.value === "rejected"
  // ) {
  //   store.dispatch(setKYCReminderModalOpen(true))
  //   store.dispatch(setKYCReminderModalType("rejected"))
  // } else {
  //   store.dispatch(setKYCReminderModalOpen(true))
  //   store.dispatch(setKYCReminderModalType("required"))
  // }
}

export const closeKYCReminderModal = () => {
  store.dispatch(setKYCReminderModalOpen(false))
}
